export default {
  anyMistakes:
    'Caso considere que as informações nesta página estão incorretas,',
  contactUs: 'contacte-nos',
  social: 'Nós somos sociais | Siga-nos',
}
